import { forwardRef } from "react";
import CollapsibleContainer, {
  CollapsibleContainerProps,
  CollapsibleContainerRef,
} from "../../../../Atoms/CollapsibleContainer/CollapsibleContainer";

export type CollapsibleProductContainerProps = Omit<
  CollapsibleContainerProps,
  "collapsibleProps"
>;
const CollapsibleProductContainer = forwardRef<
  CollapsibleContainerRef,
  React.PropsWithChildren<CollapsibleProductContainerProps>
>(({ children, ...props }, ref) => {
  return (
    <CollapsibleContainer
      ref={ref}
      {...props}
      collapsibleProps={{
        style: {
          marginBottom: "50px",
        },
      }}
    >
      {children}
    </CollapsibleContainer>
  );
});

CollapsibleProductContainer.displayName = "CollapsibleProductContainer";
export default CollapsibleProductContainer;
